/* PAWNOVA Premium v3 – reveal on scroll + welcome popup */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = w.Shopify && w.Shopify.designMode;

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    if (reduce || design || !('IntersectionObserver' in w)) return;
    d.querySelectorAll('main .shopify-section[id*="__pp_"] > *').forEach(function (el) {
      if (!/^(STYLE|SCRIPT|LINK|TEMPLATE)$/.test(el.tagName)) el.classList.add('pn-reveal');
    });
    var els = d.querySelectorAll('.pn-reveal');
    if (!els.length) return;
    root.classList.add('pn-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 6000);
  }

  /* ---------- Welcome popup ---------- */
  function initPopup() {
    var pop = d.getElementById('pn-welcome');
    if (!pop) return;
    var KEY = 'pawnova_welcome_v1';
    var SNOOZE = 3 * 864e5;
    var CODE = pop.getAttribute('data-code') || 'PAWNOVA26';
    var force = /[?&]pawnova-popup/.test(location.search);
    var copyBtn = pop.querySelector('[data-pn-copy]');
    var copyLabel = pop.querySelector('[data-pn-copy-label]');
    var codeBox = pop.querySelector('[data-pn-code]');
    var live = pop.querySelector('[data-pn-live]');
    var dialog = pop.querySelector('.pn-pop__dialog');
    var labelDefault = copyLabel ? copyLabel.textContent : '';
    var scheduled = false, isOpen = false, lastFocus = null, resetT;

    function store(k, v, session) { try { (session ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} }
    function read(k, session) { try { return (session ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } }
    function setState(s) { store(KEY, JSON.stringify({ s: s, t: Date.now() })); }
    function canShow() {
      if (force) return true;
      if (design) return false;
      if (read(KEY + '_session', true)) return false;
      var st = null;
      try { st = JSON.parse(read(KEY) || 'null'); } catch (e) {}
      if (!st) return true;
      if (st.s === 'done') return false;
      if (st.s === 'dismissed' && Date.now() - st.t < SNOOZE) return false;
      return true;
    }
    function schedule(delay) {
      if (scheduled || !canShow()) return;
      scheduled = true;
      setTimeout(open, delay);
    }
    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll('button, a[href]'), function (el) { return !el.disabled && el.offsetParent !== null; });
    }
    function onKey(e) {
      if (e.key === 'Escape') { close('dismissed'); return; }
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    function open() {
      if (isOpen || (!force && !canShow())) return;
      isOpen = true;
      store(KEY + '_session', '1', true);
      lastFocus = d.activeElement;
      pop.hidden = false;
      root.classList.add('pn-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-open'); }); });
      d.addEventListener('keydown', onKey);
      setTimeout(function () { if (copyBtn) copyBtn.focus({ preventScroll: true }); }, 420);
    }
    function close(state, after) {
      if (!isOpen) return;
      isOpen = false;
      setState(state);
      pop.classList.remove('is-open');
      pop.classList.add('is-closing');
      root.classList.remove('pn-lock');
      d.removeEventListener('keydown', onKey);
      setTimeout(function () {
        pop.hidden = true;
        pop.classList.remove('is-closing');
        if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
        if (after) after();
      }, 300);
    }
    function legacyCopy(text) {
      var ta = d.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
      dialog.appendChild(ta); ta.select(); ta.setSelectionRange(0, text.length);
      var ok = false; try { ok = d.execCommand('copy'); } catch (e) {}
      dialog.removeChild(ta); return ok;
    }
    function copied(ok) {
      setState('done');
      if (copyBtn) copyBtn.classList.add('is-copied');
      if (copyLabel) copyLabel.textContent = ok ? '✅ Codice copiato!' : 'Codice: ' + CODE;
      if (live) live.textContent = ok ? 'Codice ' + CODE + ' copiato negli appunti' : 'Copia manualmente il codice ' + CODE;
      if (codeBox) { codeBox.classList.remove('is-pulse'); void codeBox.offsetWidth; codeBox.classList.add('is-pulse'); }
      clearTimeout(resetT);
      resetT = setTimeout(function () {
        if (copyBtn) copyBtn.classList.remove('is-copied');
        if (copyLabel) copyLabel.textContent = labelDefault;
      }, 2800);
    }
    function doCopy() {
      if (navigator.clipboard && w.isSecureContext) {
        navigator.clipboard.writeText(CODE).then(function () { copied(true); }, function () { copied(legacyCopy(CODE)); });
      } else { copied(legacyCopy(CODE)); }
    }

    if (copyBtn) copyBtn.addEventListener('click', doCopy);
    if (codeBox) codeBox.addEventListener('click', doCopy);
    pop.querySelectorAll('[data-pn-close]').forEach(function (el) { el.addEventListener('click', function () { close('dismissed'); }); });
    var shop = pop.querySelector('[data-pn-shop]');
    if (shop) shop.addEventListener('click', function () {
      close('done', function () {
        var target = d.getElementById('pawnova-bestsellers');
        if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    if (!canShow()) return;

    /* Show only after the visitor has made a cookie choice */
    d.addEventListener('visitorConsentCollected', function () { schedule(700); });

    function bannerVisible() {
      var b = d.getElementById('shopify-pc__banner');
      if (!b) return false;
      var cs = w.getComputedStyle(b);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && b.offsetHeight > 0;
    }
    function watchBanner(initialWait, grace) {
      var seen = false, ticks = 0;
      setTimeout(function () {
        var iv = setInterval(function () {
          ticks++;
          var vis = bannerVisible();
          if (vis) seen = true;
          if (!vis && (seen || ticks >= grace)) { clearInterval(iv); schedule(seen ? 700 : 1500); }
          if (ticks > 400) clearInterval(iv);
        }, 700);
      }, initialWait);
    }

    if (force) { schedule(600); return; }
    var S = w.Shopify;
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        var cp = w.Shopify && w.Shopify.customerPrivacy;
        if (err || !cp || typeof cp.shouldShowBanner !== 'function') { watchBanner(2500, 1); return; }
        var needsBanner = true;
        try { needsBanner = cp.shouldShowBanner(); } catch (e) {}
        if (!needsBanner) schedule(2500);
        else watchBanner(1500, 12);
      });
    } else {
      watchBanner(2500, 1);
    }
  }

  function init() { initReveal(); initPopup(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
